import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host {\n  display: block;\n}\n\n.chc-c-article-group ::slotted([slot=heading]) {\n  color: var(--leaf-color-content-brand-strong);\n}\n.chc-c-article-group ::slotted([slot=description]) {\n  margin-top: var(--leaf-spacing-16);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCArticleGroup = class _CHCArticleGroup extends LeafElement {
  constructor() {
    super(...arguments);
    this.headingSize = "large";
  }
  render() {
    const componentClassName = {
      "chc-c-article-group": true
    };
    return html` <div class=${classMap(componentClassName)}>
      <slot name="heading"></slot>
      <slot name="description"></slot>
      <slot></slot>
    </div>`;
  }
};
_CHCArticleGroup.styles = unsafeCSS(styles);
let CHCArticleGroup = _CHCArticleGroup;
__decorateClass([
  property({ reflect: true, attribute: "heading-size" })
], CHCArticleGroup.prototype, "headingSize", 2);
export {
  CHCArticleGroup
};
//# sourceMappingURL=article-group.component.js.map
